import useAsyncAction from 'modules/core/hooks/useAsyncAction'
import { dateUIToBackend } from 'modules/core/lib/dates'
import i18n from 'modules/core/lib/i18n'

import { exportYearlyBalance } from 'modules/shift_management/lib/Api/exportYearlyBalance'
import { trackYearlyExportSubmit } from 'modules/shift_management/lib/trackEvents'

interface Props {
  startDate: string
  endDate: string
  teamsIds: number[]
  locationsIds: number[]
  from: string
  onSuccess: () => void
}

const useExportYearlyBalance = ({
  startDate,
  endDate,
  teamsIds,
  locationsIds,
  from,
  onSuccess,
}: Props) => {
  const { running: submitting, performAction } = useAsyncAction(
    async () => {
      trackYearlyExportSubmit(startDate, endDate, teamsIds, locationsIds, from)
      const payload = {
        date_from: dateUIToBackend(startDate),
        date_to: dateUIToBackend(endDate),
        teams_ids: teamsIds,
        locations_ids: locationsIds,
      }

      await exportYearlyBalance(payload)

      if (onSuccess) {
        onSuccess()
      }
    },
    {
      successMessage: i18n.t('clock_in.modals.export.notice'),
    }
  )

  return {
    onSubmit: performAction,
    submitting: submitting,
  }
}

export default useExportYearlyBalance
